import React, { FC } from 'react'
import styled from 'styled-components'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'

import { ISchoolInfoItemProps } from '../types'

// Текст может приходить с символами переноса и пробела
// выводим текст соблюдая все переносы но чистим от пробелов
const TextStyled = styled(Text)`
  white-space: pre-line;
`

export const Item: FC<ISchoolInfoItemProps> = ({ title, description }) => (
  <>
    <Heading h4={title} spacing='xxsmall' />
    <TextStyled>{String(description).replace(/&nbsp;/g, '')}</TextStyled>
    <Spacing spacing='medium' />
  </>
)
